// removed by extract-text-webpack-plugin
module.exports = {"Remove":"RemoveTile__Remove__1iFYi","Attempts":"RemoveTile__Attempts__3TmVn","ToolTipText":"RemoveTile__ToolTipText__24Yro","Clicked":"RemoveTile__Clicked__JGkUz","Remind":"RemoveTile__Remind__3NJkZ","shake":"RemoveTile__shake__R7Mfy"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/GameMenu/ListElements/RemoveTile/RemoveTile.css
// module id = 104
// module chunks = 0